import 'kontra'
import Snake from './objects/snake'
import GameMap from './objects/map'
import sheet from './assets/images/sheet.png'
import dripSheet from './assets/images/drip.png'
import heartSheet from './assets/images/heart.png'
import sparkleSheet from './assets/images/sparkle.png'
import splashSheet from './assets/images/splash.png'
import tileset from './assets/maps/sheet.json'
import Crop from './objects/crop'
import Effect from './objects/effect'
import plantSound from './assets/sounds/plant.mp3'
import chompSound from './assets/sounds/chomp.mp3'
import waterstepSound from './assets/sounds/waterstep.mp3'
import dripSound from './assets/sounds/drip.mp3'
import dirtSound from './assets/sounds/dirt.mp3'
import deathSound from './assets/sounds/death.mp3'
import squealSound from './assets/sounds/squeal.mp3'
import musicSound from './assets/sounds/music.mp3'
import Worm from './objects/worm'

const BurrowSheet = {
  LEFT_LEFT: 79,
  RIGHT_RIGHT: 79,
  UP_UP: 87,
  DOWN_DOWN: 87,
  UP_RIGHT: 77,
  LEFT_DOWN: 77,
  RIGHT_DOWN: 78,
  DOWN_RIGHT: 78,
  UP_LEFT: 78,
  RIGHT_UP : 86,
  DOWN_LEFT: 86,
  LEFT_UP: 85,
  DOWN_RIGHT: 85
}

const burrowTiles = [79, 77, 78, 79, 85, 86, 87]

global.started = false
global.selectedMap = 1

global.reset = () => {
  const startX = Maps[selectedMap].properties.find(x => x.name === 'START_X').value
  const startY = Maps[selectedMap].properties.find(x => x.name === 'START_Y').value

  global.map = GameMap()
  global.snake = Snake(startX * GRID, startY * GRID)
  global.crops = []
  global.effects = []
  global.waiting = true
  global.stopped = false
  global.dirQueue = []
  global.cropQueue = []
  global.wormTimer = 10
  global.worms = []
  global.gameover = false
}

async function main() {
  kontra.init('gamecanvas')

  await kontra.assets.load(
    sheet,
    dripSheet,
    heartSheet,
    sparkleSheet,
    splashSheet,
    plantSound,
    chompSound,
    waterstepSound,
    dirtSound,
    dripSound,
    deathSound,
    squealSound,
  )

  reset()

  kontra.keys.bind('left', () => {
    waiting = false
    if (dirQueue.length < 3 && dirQueue[0] !== LEFT) {
      dirQueue.push(LEFT)
    }
  })
  kontra.keys.bind('right', () => {
    waiting = false
    if (dirQueue.length < 3 &&  dirQueue[0] !== RIGHT) {
      dirQueue.push(RIGHT)
    }
  })
  kontra.keys.bind('up', () => {
    waiting = false
    if (dirQueue.length < 3 &&  dirQueue[0] !== UP) {
      dirQueue.push(UP)
    }
  })
  kontra.keys.bind('down', () => {
    waiting = false
    if (dirQueue.length < 3 &&  dirQueue[0] !== DOWN) {
      dirQueue.push(DOWN)
    }
  })
  kontra.keys.bind('z', () => {
    if (cropQueue.length < 3 && cropQueue[0] !== Crops.CABBAGE) {
      cropQueue.push(Crops.CABBAGE)
    }
  })
  kontra.keys.bind('x', () => {
    if (cropQueue.length < 3 && cropQueue[0] !== Crops.STRAWBERRIES) {
      cropQueue.push(Crops.STRAWBERRIES)
    }
  })
  kontra.keys.bind('c', () => {
    if (cropQueue.length < 3 && cropQueue[0] !== Crops.WATERMELON) {
      cropQueue.push(Crops.WATERMELON)
    }
  })

  const loop = kontra.gameLoop({
    fps: FPS,

    update() {
      if (!started) return
      if (stopped || waiting) {
        return
      }

      const nextDir = dirQueue.shift()
      switch (nextDir) {
      case LEFT:
        if (snake.dir !== RIGHT) snake.nextDir = nextDir
        break
      case RIGHT:
        if (snake.dir !== LEFT) snake.nextDir = nextDir
        break
      case UP:
        if (snake.dir !== DOWN) snake.nextDir = nextDir
        break
      case DOWN:
        if (snake.dir !== UP) snake.nextDir = nextDir
        break
      }

      // wormTimer--
      // if (wormTimer <= 0) {
      //   wormTimer = 30
      //   const availableTiles = map.layers[0].data.map(({ type }, i) => ({ type, i })).filter(tile => tile.type === Tiles.DIRT).map(x => x.i)
      //   const wormTile = availableTiles[randomBetween(0, availableTiles.length - 1)]
      //   if (!wormTile) {
      //     return
      //   }
      //   const wormX = wormTile % MAP_WIDTH
      //   const wormY = Math.floor(wormTile / MAP_WIDTH)
      //   worms.push(Worm(wormX * GRID, wormY * GRID))
      // }

      snake.update()
      map.update()
      crops.forEach(crop => crop.update())
      effects.forEach(effect => effect.update())
      worms.forEach(worm => worm.update())

      effects = effects.filter(x => !x.finished)

      if (!snake.trail[1]) {
        return
      }

      const { tx, ty } = getTilePos(snake.trail[1])

      const groundTile = map.getTile(0, tx, ty)
      const featureTile = map.getTile(1, tx, ty)

      switch (groundTile.type) {
      case Tiles.DIRT:
        const existingCropIndex = crops.findIndex(crop => {
          const cropPos = getTilePos(crop)
          return cropPos.tx === tx && cropPos.ty === ty
        })
        const existingCrop = crops[existingCropIndex]

        if ((!existingCrop || (snake.water === 0 || existingCrop.water === MAX_WATER)) && featureTile.type !== Tiles.WATER) {
          // kontra.assets.audio[dirtSound].cloneNode().play()
        }

        if (existingCrop) {
          if (existingCrop.growth === 4) {
            snake.length += CropValue[existingCrop.type] * 2
            kontra.assets.audio[chompSound].cloneNode().play()
            crops.splice(existingCropIndex, 1)
            effects.push(Effect({
              x: snake.trail[1].x,
              y: snake.trail[1].y,
              effectType: Effects.HEART
            }))
          }
        } else if (burrowTiles.includes(groundTile.id) && cropQueue.length > 0 && snake.length > 3) {
          // plant crop
          crops.push(Crop(tx * GRID, ty * GRID, cropQueue.shift()))
          kontra.assets.audio[plantSound].cloneNode().play()
          snake.cut(1)
        }

        const burrowDir = `${snake.trail[1].dir}_${snake.lastDir}`
        const burrowTile = BurrowSheet[burrowDir]
        map.setTile(0, tx, ty, burrowTile)

        break
      default:
      }

      if (featureTile.type === Tiles.WATER) {
        kontra.assets.audio[waterstepSound].cloneNode().play()
        if (snake.water < snake.length - 2) {
          snake.water++
        }
      } else if (featureTile.type === Tiles.ROCK) {
        reset()
      }

      for (let i = 0; i < snake.trail.length; i++) {
        const { tx, ty } = getTilePos(snake.trail[i])
        const bodyGroundTile = map.getTile(0, tx, ty)
        const bodyFeatureTile = map.getTile(1, tx, ty)

        switch (groundTile.type) {
        case Tiles.DIRT:
          // water crops from bulges
          if (i > 0 && snake.water >= i) {
            const existingCrop = crops.find(crop => {
              const cropPos = getTilePos(crop)
              return cropPos.tx === tx && cropPos.ty === ty
            })
            if (existingCrop && existingCrop.growth < 4 && existingCrop.water < MAX_WATER) {
              existingCrop.water = MAX_WATER
              kontra.assets.audio[dripSound].cloneNode().play()
              snake.water--
              effects.push(Effect({
                x: snake.trail[i].x + 3,
                y: snake.trail[i].y - 6,
                effectType: Effects.DRIP
              }))
            }
          }
          break
        default:
        }
      }

      for (const worm of worms) {
        const { tx, ty } = getTilePos(worm)
        if (worm.burrowTimer > 1) {
          map.setTile(0, tx, ty, worm.burrowTimer % 2 === 0 ? 100 : 101)
        } else if (worm.burrowTimer === 1) {
          map.setTile(0, tx, ty, 102)
        }
      }
    },

    render() {
      if (!started) return
      map.render()
      crops.forEach(crop => crop.render())
      snake.render()
      worms.forEach(worm => worm.render())
      effects.forEach(effect => effect.render())
      if (waiting) {
        kontra.context.font = '30px PixelHead'
        kontra.context.fillStyle = 'white'
        kontra.context.shadowOffsetX = 2;
        kontra.context.shadowOffsetY = 2;
        kontra.context.shadowColor = "rgba(0,0,0,1)";
        kontra.context.shadowBlur = 0
        kontra.context.fillText('Press an arrow key to start moving...', 20, 240)
        kontra.context.shadowOffsetX = 0;
        kontra.context.shadowOffsetY = 0;
        kontra.context.shadowColor = "";
        kontra.context.shadowBlur = 0
      }
      if (stopped) {
        kontra.context.font = '30px PixelHead'
        kontra.context.fillStyle = 'white'
        kontra.context.shadowOffsetX = 2;
        kontra.context.shadowOffsetY = 2;
        kontra.context.shadowColor = "rgba(0,0,0,1)";
        kontra.context.shadowBlur = 0
        kontra.context.fillText('Press any key to restart...', 100, 200)
        kontra.context.shadowOffsetX = 0;
        kontra.context.shadowOffsetY = 0;
        kontra.context.shadowColor = "";
        kontra.context.shadowBlur = 0
        // kontra.context.strokeText('Press any key to restart...', 100, 200)
      }
    }
  })

  loop.start()
}

main()

const music = new Audio(musicSound)

window.playGame = function(map) {
  music.loop = true
  music.currentTime = 0
  music.volume = 0.2
  music.play()
  selectedMap = map
  reset()
  started = true
  document.getElementById('gamecanvas').style.zIndex = 9999
}


window.addEventListener('keydown', (e) => {
  if (e.keyCode === 27) {
    started = false
    music.pause()
    document.getElementById('gamecanvas').style.zIndex = 0
  } 
  if (gameover) {
    started = false
    music.pause()
    document.getElementById('gamecanvas').style.zIndex = 0
  }
})